import React from 'react'
import {Header, Container, Icon} from 'semantic-ui-react'
import SidebarComponent from '../layout/SidebarComponent'
import { getSortStatusName } from './options'
import styles from './sidebar.module.scss'
import classNames from 'classnames'

const SidebarPanel = ({ visible, typeName, item, close, edit }) => {

  return (
      <SidebarComponent visible={visible}>
          <Container as="div" className={styles.containerMenu}>
              <Icon name="pencil"  onClick={edit} className={styles.pointer}/>
              &nbsp;
              <Icon name="close" onClick={close} className={styles.pointer}/>
          </Container>

          <Header as="h3" className={styles.marginB30}>
              Details
          </Header>

          <div className={styles.marginB30}>
              <p className={styles.pH}>
                  {typeName.toUpperCase()} NAME
              </p>
              <p className={styles.pStrong}>{item.data.name}</p>
          </div>

          {item.data.type === "data-object" && item.data.dataElements !== null && item.data.dataElements.length > 0 &&
          <div className={classNames(styles.panelBox, styles.marginB30)} >
              <p className={styles.pH}>RELATED DATA ELEMENTS</p>
              {item.data.dataElements.map( (i, index) => {
                  return <div key={index}>
                      <p>{i.name}</p>
                  </div>
              })}
          </div>}

          {item.data.type === "data-element" && item.data.dataType && item.data.dataType.name &&
          <div className={styles.marginB30} >
              <p className={styles.pH}>DATA TYPE</p>
              <p>{item.data.dataType.name}</p>
          </div>
          }
          {item.data.type === "data-element" && ((item.data.dataObjects !== null && item.data.dataObjects.length > 0) || (item.data.sampleValues !== null && item.data.sampleValues.length > 0)) &&
          <div className={classNames(styles.panelBox, styles.marginB30)} >
              {item.data.dataObjects !== null && item.data.dataObjects.length > 0 &&
              <>
                  <p className={styles.pH}>RELATED DATA OBJECTS</p>
                  {item.data.dataObjects.map( (i, index) => {
                      return <div key={index}>
                          <p>{i.name}</p>
                      </div>
                  })}
              </>}
              {item.data.dataObjects !== null && item.data.dataObjects.length > 0 &&
                  item.data.sampleValues !== null && item.data.sampleValues.length > 0 &&
                    <hr/>}
              {item.data.sampleValues !== null && item.data.sampleValues.length > 0 &&
              <>
                  <p className={styles.pH}>RELATED SAMPLE VALUES</p>
                  {item.data.sampleValues && item.data.sampleValues.map( (i, index) => {
                      return <div key={index}>
                          <p>
                              <span>{i.name}</span>
                              {i.termRelationship && i.termRelationship.type === "constrained-by" && <span style={{float: "right", color: "#787885", fontSize: "12px"}}>CB</span>}
                              {i.termRelationship && i.termRelationship.type === "demonstrated-by" && <span style={{float: "right", color: "#787885", fontSize: "12px"}}>DB</span>}
                          </p>
                      </div>
                  })}
              </>}
          </div>}

          <div className={styles.marginB30}>
              <p className={styles.pH}>{typeName.toUpperCase()} DEFINITION</p>
              <p>{item.data.definition}</p>
          </div>

          {item.data.type === "data-object" && item.data.dataDomain && item.data.dataDomain.name &&
          <div className={styles.marginB30}>
              <p className={styles.pH}>DOMAIN</p>
              <p>{item.data.dataDomain.name}</p>
          </div>}

          <div className={styles.marginB30}>
              <p className={styles.pH}>STATUS</p>
              <p>{getSortStatusName(item.data.status)}</p>
          </div>

    </SidebarComponent>

  )
}

export default SidebarPanel